import { render, staticRenderFns } from "./msg-item.vue?vue&type=template&id=e7f54c7a&scoped=true&"
import script from "./msg-item.vue?vue&type=script&lang=js&"
export * from "./msg-item.vue?vue&type=script&lang=js&"
import style0 from "./msg-item.vue?vue&type=style&index=0&id=e7f54c7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f54c7a",
  null
  
)

export default component.exports